export enum InternalDataTypeEnum {
  'Classifications' = 'Classifications',
  'Translations' = 'Translations',
}

export const DataType = { ...InternalDataTypeEnum };
export type DataType = InternalDataTypeEnum;
